import { Fragment, type PropsWithChildren, useEffect } from "react"
import { useTheme } from "@/shared/hooks/useTheme.ts"

export function ThemeProvider({ children }: PropsWithChildren) {
  const { isDark } = useTheme()

  useEffect(() => {
    document.documentElement.setAttribute("theme", isDark ? "dark" : "light")
  }, [isDark])
  return <Fragment children={children} />
}
